type SpriteMap = {
  [key: string]: string
}

const useSpriteMapper = () => {
  const spriteMap: SpriteMap = {
    'turtle boy': 'turtle_boy'
  }

  return { spriteMap }
}

export default useSpriteMapper
